import { FormattedMessage } from "react-intl";

import { ContractFeatures, type IToken } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { TokenTraitsView } from "./traits";
import { StyledToolbar } from "./styled";

export interface ITraitTokenPanelProps {
  token: IToken;
}

export const TraitTokenPanel = (props: ITraitTokenPanelProps) => {
  const { token } = props;

  if (!token.template?.contract?.contractFeatures.includes(ContractFeatures.TRAITS)) {
    return null;
  }

  return (
    <Card>
      <Card.Content>
        <StyledToolbar disableGutters>
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.token.traits" />
          </Typography>
        </StyledToolbar>
        <TokenTraitsView metadata={token.metadata} />
      </Card.Content>
    </Card>
  );
};
